import styled from 'styled-components';

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const Container = styled.div``;
